'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dAudit$002dView$0024$0024anon$00245 from "./presto.-Audit-View$$anon$5.js";
import * as $j_presto$002e$002dAudit$002dView$0024$002dAudit$002dName$0024 from "./presto.-Audit-View$-Audit-Name$.js";
var $p;
/** @constructor */
function $c_Lpresto_AuditView$$anon$4() {
  this.aBz = null;
  this.aBr = null;
  this.aBs = false;
  this.aBA = null;
  this.aBB = false;
  this.aBE = null;
  this.aBx = null;
  this.aBy = false;
  this.aBt = null;
  this.aBu = false;
  this.aBv = null;
  this.aBw = false;
  this.aBC = false;
  this.aBD = false;
  this.aBz = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.aBE = "AuditName";
}
export { $c_Lpresto_AuditView$$anon$4 as $c_Lpresto_AuditView$$anon$4 };
$p = $c_Lpresto_AuditView$$anon$4.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_AuditView$$anon$4;
/** @constructor */
function $h_Lpresto_AuditView$$anon$4() {
}
export { $h_Lpresto_AuditView$$anon$4 as $h_Lpresto_AuditView$$anon$4 };
$h_Lpresto_AuditView$$anon$4.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.aBz;
});
$p.L = (function() {
  if ((!this.aBs)) {
    this.aBr = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.aBs = true;
  }
  return this.aBr;
});
$p.O = (function() {
  if ((!this.aBB)) {
    this.aBA = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.aBB = true;
  }
  return this.aBA;
});
$p.E = (function() {
  return this.aBE;
});
$p.t = (function() {
  if ((!this.aBy)) {
    this.aBx = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("name", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("deleted", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.aBy = true;
  }
  return this.aBx;
});
$p.M = (function() {
  if ((!this.aBu)) {
    this.aBt = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().aa, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().ar, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.aBu = true;
  }
  return this.aBt;
});
$p.Q = (function() {
  if ((!this.aBw)) {
    this.aBv = new $j_presto$002e$002dAudit$002dView$0024$0024anon$00245.$c_Lpresto_AuditView$$anon$5();
    this.aBw = true;
  }
  return this.aBv;
});
$p.w = (function() {
  if ((!this.aBD)) {
    this.aBC = false;
    this.aBD = true;
  }
  return this.aBC;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee70) => ((p) => \u03b4scrutinee70.cFU(p)))($j_presto$002e$002dAudit$002dView$0024$002dAudit$002dName$0024.$m_Lpresto_AuditView$AuditName$())));
});
var $d_Lpresto_AuditView$$anon$4 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_AuditView$$anon$4, "presto.AuditView$$anon$4", ({
  EA: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_AuditView$$anon$4 as $d_Lpresto_AuditView$$anon$4 };
//# sourceMappingURL=presto.-Audit-View$$anon$4.js.map
